/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Draft_Review_ChangesInputs */

const en_us2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review changes`)
};

const pt_br2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar mudanças`)
};

const es_419_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar cambios`)
};

const pt_pt2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever alterações`)
};

const fr_fr2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoir les changements`)
};

const de_de2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen prüfen`)
};

const it_it2_plan_draft_review_changes = /** @type {(inputs: Plan_Draft_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi le modifiche`)
};

/**
* | output |
* | --- |
* | "Review changes" |
*
* @param {Plan_Draft_Review_ChangesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_draft_review_changes = /** @type {((inputs?: Plan_Draft_Review_ChangesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Draft_Review_ChangesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_draft_review_changes(inputs)
	if (locale === "es-419") return es_419_plan_draft_review_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_draft_review_changes(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_draft_review_changes(inputs)
	if (locale === "de-DE") return de_de2_plan_draft_review_changes(inputs)
	if (locale === "it-IT") return it_it2_plan_draft_review_changes(inputs)
	return en_us2_plan_draft_review_changes(inputs)
});
export { plan_draft_review_changes as "plan.draft_review_changes" }